<!-- 项目类型 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector
      v-bind="config"
      v-model="productTypes"
      type="productTypes"
      clearable
      :multiple="config.multiple"/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-项目类型',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '项目类型：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const productTypes = useQuery('productTypes', props.value);

    return {
      productTypes,
    };
  },
};
</script>
